import { Box, Button, Checkbox, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import DropDownOA from '../../../common/dropDownOA'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import RateMatrixFileUpload from './rateMatrixFileUpload'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import KGKMMatrixHistory from './kgkmMatrixHistory'
import KgkmMatrixDelete from './kgkmMatrixDelete'
import { cargoServiceTypes, kgkmTableHead, kgkmTableHeadPdf } from './rateMatrixConstants'
import { FilterInput } from '../../../common/filterInput'
import { ratematrxiHistoryDataDummy, kgkmTabledataDummy } from './dummyConstans'
import { getFocApprConsTypeData, GetKgKmRateMatrixTblData, getServiceTypeListAllData, kgKmRateMatrixUpdate, GetKgKmRateMatrixHistoryTblData } from '../../../../store/generalSetting/GSAction'
import moment from 'moment'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import TablePaginationCustom from '../../../common/TablePagination'
import { RenderTable } from '../../Reports/analysisReport/summmaryTable'

const KGKMRateMatrix = (props) => {
  const { data, updateModal, updateAlertError, getFocApprConsTypeData, getServiceTypeListAllData, GetKgKmRateMatrixTblData, kgKmRateMatrixUpdate, GetKgKmRateMatrixHistoryTblData } = props
  const theme = useTheme()
  const { common, generalSettingReducer, } = data
  const { loginData, showModal, modalType } = common
  const { focApprConsTypeData, serviceTypeListAll, kgKmRateMatrixData,kgKmDocChrgData, kgKmRateMatrixHistoryData, serviceTypeListAll2 } = generalSettingReducer
  const [filters, setFilters] = useState({ cargoServiceType: cargoServiceTypes[0], multiCargoServiceType: '', consType: '' })
  const [consTypeList, setConsTypeList] = useState([])
  const [tableData, setTableData] = useState([])
  const [tableData1, setTableData1] = useState([])
  const [showTable, setShowTable] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [filterValues, setFilterValues] = useState({});
  const [serviceTypeOpt, setServiceTypeOpt] = useState([])
  const [manageFocus, setManageFocus] = useState(false)
  const [isSave, setIsSave] = useState(false)
  const [showKgKmUpload, setShowKgKmUpload] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(0)
  const [totalNoOfRows, setTotalNoOfRows] = useState(0)
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    setTimeout(() => {
      focusElemnt('kgKmCargoServiceType')
    }, 10);
  }, [])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      let obj = {
        intConsignmentSubTypeID: 0,
        intCompanyID: loginData?.intCompanyID,
        intConsignmentTypeID: 0,
        strSubType: "",
        intIsActive: 1,
        intIsDeleted: 0
      }
      getFocApprConsTypeData(obj, true, 24 * 60 * 60 * 1000)
    }
  }, [loginData])
  useEffect(() => {
    if (serviceTypeListAll?.length > 0) {
      let data = serviceTypeListAll?.filter((val) => serviceTypeListAll2?.length > 0 ? serviceTypeListAll2?.[0]?.CargoServiceTypeID === 0 ? val?.ServiceTypeID === 2 : true : true)
      if (Number(serviceTypeListAll2?.[0]?.CargoServiceTypeID) === 1) {
        setFilters((prev) => ({
          ...prev,
          cargoServiceType: cargoServiceTypes[1]
        }))
      } else {
        setFilters((prev) => ({
          ...prev,
          cargoServiceType: cargoServiceTypes[0]
        }))
      }
      setServiceTypeOpt(data)
      setFilters((prev) => ({
        ...prev,
        multiCargoServiceType: data[0]
      }))
    } else {
      setServiceTypeOpt([])
      setFilters((prev) => ({
        ...prev,
        multiCargoServiceType: ''
      }))

    }
  }, [serviceTypeListAll, serviceTypeListAll2])
  useEffect(() => {
    if (focApprConsTypeData?.length > 0) {
      let newData = [{ id: 0, name: 'All' }]
      focApprConsTypeData.map(function (obj) {
        newData.push({
          id: obj.ConsignmentSubTypeID,
          name: obj.SubType,
        })
      })
      newData = removeDuplicatesFromArray(newData, `id`)
      newData.sort((a, b) => a.name.localeCompare(b.name))
      setConsTypeList(newData)
      setFilters((prev) => ({
        ...prev,
        consType: newData[0]
      }))
    } else {
      setConsTypeList([])
    }
  }, [focApprConsTypeData])
  useEffect(() => {
    if (kgKmRateMatrixData?.Table?.length > 0) {
      const sortedData = [...kgKmRateMatrixData?.Table].sort((a, b) => {
        if (a.ServiceType < b.ServiceType) return -1;
        if (a.ServiceType > b.ServiceType) return 1;
        return 0;
      });

      // Step 2: Add 'srNo' property for serial numbers
      const dataWithSrNo = sortedData.map((item, index) => ({
        ...item,
        editBtn: true,
        // srNo: index + 1,
        rateVal: item?.Rate,
        docChrgeVal: item?.DocumentCharge,
        EntryDateTime: moment(item?.EntryDateTime).format('HH:mm, DD-MMM-YY'),
      }));
      dataWithSrNo.sort((a, b) => {
        // if (a.FromCity !== b.FromCity) {
        //   return a.FromCity.localeCompare(b.FromCity);
        // }
        return a.ToKg - b.ToKg;
      })
      const newData = dataWithSrNo?.map((item, index) => ({ ...item, srNo:(page)*rowsPerPage+ index + 1 }))

      // Step 3: Set the sorted data with serial numbers
      setFilteredData(newData);
      setTotalNoOfRows(kgKmRateMatrixData?.Table2?.[0]?.TotalRows)
    } else {
      setFilteredData([])
      setTotalNoOfRows(0)
    }
  }, [kgKmRateMatrixData])
  useEffect(()=>{
    if(kgKmDocChrgData){
      setTableData1(kgKmDocChrgData)
    }
  },[kgKmDocChrgData])
  useEffect(() => {
    // if (filteredData?.length > 0) {
    setTableData(filteredData)
    // }
  }, [filteredData])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let body = {
        CompanyID: loginData?.intCompanyID,
        CargoServiceType: cargoServiceTypes?.[0]?.id,
        ServiceTypeID: 2,
        ConsignmentID: 0
      }
      GetKgKmRateMatrixTblData(body)
    }
  }, [loginData])
  const loadServiceType = (page=0, rowsPerPage=10) => {
    setShowTable(true)
    if (filters?.cargoServiceType === '') {
      updateAlertError({ show: true, msg: 'Please Select Cargo Service Type', success: false, nextId: `` })
    } else if (filters?.multiCargoServiceType === '') {
      updateAlertError({ show: true, msg: 'Please Select Multi Cargo Service Type', success: false, nextId: `` })
    } else if (filters?.consType === '') {
      updateAlertError({ show: true, msg: 'Please Select Consignment Type', success: false, nextId: `` })
    } else {
      let body = {
        CompanyID: loginData?.intCompanyID,
        CargoServiceType: filters?.cargoServiceType?.id,
        ServiceTypeID: filters?.multiCargoServiceType?.ServiceTypeID,
        ConsignmentID: filters?.consType?.id,
        PageNo:page+1,
        NoOfRows:rowsPerPage
      }
      GetKgKmRateMatrixTblData(body)
    }
  }

  const StyledCheckbox = (props) => <Checkbox {...props} sx={{ padding: 0 }} />
  const StyledEdit = (props) => (
    <span
      {...props}
      style={{
        padding: 0,
        fontSize: '14px',
        color: theme.palette.primary.main,
      }}
    >
      Edit
    </span>
  )
  const showKgKmUploadPopup = () => {
    const data = {
      loginData,
      isUpdate: true,
      headText: 'Add New Rates',
      branchAndCityOpt: '',
    }
    const methods = {
      updateModal:()=>{setShowKgKmUpload(false)},
      kgKmRateMatrixUpdate,
      updateAlertError
    }
    return <RateMatrixFileUpload data={data} methods={methods} tableData1={tableData1} />
  }
  const showKgKmHistoryPopup = () => {
    const data = {
      // loginData,
      isUpdate: true,
      headText: 'KG KM Matrix History',
      branchAndCityOpt: '',
      listData: ratematrxiHistoryDataDummy,
      cargoServiceTypes: cargoServiceTypes,
      serviceTypeListAll: serviceTypeListAll,
      consTypeList: consTypeList
    }
    const methods = {
      updateModal,
      getServiceTypeListAllData,
      GetKgKmRateMatrixHistoryTblData,
      // updateAlertError,
    }
    return <KGKMMatrixHistory data={data} methods={methods} />
  }
  const showKgKmDeletePopup = () => {
    const data = {
      loginData,
      isUpdate: true,
      headText: 'Delete KG-KM Matrix',
      branchAndCityOpt: '',
      listData: ratematrxiHistoryDataDummy,
      cargoServiceTypes: cargoServiceTypes,
      serviceTypeListAll: serviceTypeListAll,
      consTypeList: consTypeList,
      isDelete: true,
    }
    const methods = {
      updateModal,
      getServiceTypeListAllData,
      GetKgKmRateMatrixHistoryTblData,
      kgKmRateMatrixUpdate
      // updateAlertError,
    }
    return <KgkmMatrixDelete tableData1={tableData1}/>
  }

  const handleChangeContain = (e, name) => {
    let value = e.target.value;
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value
    }));
  }

  const handleEditRow = (index, row) => {
    let newData = [...tableData]

    newData[index].editBtn = !row?.editBtn
    if (row?.editBtn) {
      newData[index].rateVal = newData[index].Rate
      newData[index].docChrgeVal = newData[index].DocumentCharge
    }
    if (!newData[index].editBtn) {
      setManageFocus(true)
    } else {
      setManageFocus(false)
    }
    setTableData(newData)
  }
  const handleInputChange = (e, key, index) => {
    let newData = [...tableData]
    newData[index][key] = e.target.value
    setTableData(newData)
    if (key === 'rateVal') {
      setManageFocus(true)
    } else {
      setManageFocus(false)
    }
  }
  const handleSave = (e) => {
    let selectedRows = tableData?.filter(item => item.editBtn === false)?.length
    if (selectedRows <= 0) {
      updateAlertError({ show: true, msg: 'Please  Select Atleast One Row For\n Editing And Then Save', success: false, nextId: `` })
    } else {
      let body = {
        CompanyID: loginData?.intCompanyID,
        LoginUserID: loginData?.intUserID,
        ConsignmentIDs: '',
        FromKgs: '',
        ToKgs: '',
        FromKms: '',
        ToKms: '',
        Rates: tableData
          .filter(item => item.editBtn === false)
          .map(item => item.rateVal)
          .join(','),
        ConsignmentID: 0,
        Mode: 3,
        RateIDs: tableData
          .filter(item => item.editBtn === false)
          .map(item => item.RateID)
          .join(','),
        DocumentCharges: tableData
          .filter(item => item.editBtn === false)
          .map(item => item.docChrgeVal)
          .join(','),
        ServiceTypeIDs: '',
        ServiceTypeID: 0,
        IsDocChgFixed: tableData1?.[0]?.IsDocChgFixed,
        FixedDocChg: tableData1?.[0]?.FixedDocChg
      }
      kgKmRateMatrixUpdate(body).then((res) => {
        if (res?.status === 'Success') {
          setIsSave(true)
        } else {
          updateAlertError({ show: true, msg: res.Message, success: false, nextId: `` })
        }

      })
    }

  }

  const handleInputBlur = (value, type, index) => {
    // Add a short delay before handling the blur event to prevent re-render focus loss
    setTimeout(() => {
      handleInputChange({ target: { value } }, type, index);
    }, 100); // Delay can be adjusted, 100ms works in most cases
  };
  useEffect(() => {
    const filteredDataTemp = filteredData.filter((item) => {
      return kgkmTableHead?.every((column) => {
        const filterValue = filterValues[column.field]; // Can be 0 or any other value
        const value = item[column.field]; // The value in the row
        if (filterValue !== undefined && filterValue !== "") {
          return value != null && value?.toString()?.toLowerCase()?.includes(filterValue?.toString()?.toLowerCase());
        }
        return true;
      });
    });
    // setTableData(filteredDataTemp);
    setTableData(filteredDataTemp.length > 0 ? filteredDataTemp : []);
  }, [filterValues]);


  const KgKmTblRow = (props) => {
    const { item, index } = props
    // const [rateInput, setRateInput] = useState(item?.Rate || 0);
    // const [docChargeInput, setDocChargeInput] = useState(item?.DocumentCharge || 0);

    return (
      <TableRow key={`foc-approval-${index}`} style={{ minHeight: '40px' }}>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item?.srNo} </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {item.ServiceTypeID} </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {item.ServiceType} </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {item.ConsignmentID} </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {item.SubType} </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.FromKg} </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.ToKg} </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.FromKm} </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.ToKm} </TableCell>
        {item.editBtn ? <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.rateVal} </TableCell> :
          <TableCell className="input--wrapper" style={{ fontSize: '12px', color: '#444444', padding: '0px 16px 0px 16px' }}>
            <Item sx={{ width: '100%', padding: '0px' }}>
              <input
                id={`focApprAuthName-${index}`}
                name={`focApprAuthName-${index}`}
                className='input--style'
                autoFocus={manageFocus}
                style={{ fontSize: "12px" }}
                value={item?.rateVal || 0}
                onChange={(e) => handleInputChange(e, 'rateVal', index)}
                onBlur={(e) => { setManageFocus(false) }}
              // onKeyDown={(e) => { navigation3(e, `chkbox-${index}`, `checkMark-${index}`) }}
              />
            </Item>
          </TableCell>}
        {item.editBtn ? <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.docChrgeVal} </TableCell> :
          <TableCell className="input--wrapper" style={{ fontSize: '12px', color: '#444444', padding: '0px 16px 0px 16px' }}>
            <Item sx={{ width: '100%', padding: '0px' }}>
              <input
                id={`focApprAuthName-${index}`}
                name={`focApprAuthName-${index}`}
                className='input--style'
                autoFocus={!item?.editBtn && !manageFocus}
                style={{ fontSize: "12px" }}
                value={item?.docChrgeVal || 0}
                onChange={(e) => handleInputChange(e, 'docChrgeVal', index)}
              // onKeyDown={(e) => { navigation3(e, `chkbox-${index}`, `checkMark-${index}`) }}
              />
            </Item>
          </TableCell>}
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}>
          <>
            <StyledCheckbox checked={!item?.editBtn} onChange={(e) => handleEditRow(index, item)} />
            <StyledEdit />
          </>
        </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {item.UserName} </TableCell>
        <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {item.EntryDateTime} </TableCell>
      </TableRow>
    )
  }

  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={14}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>No results found for the selected filters.</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }
  const handleCloseSuccessModal = () => {
    loadServiceType(page, rowsPerPage);
    focusElemnt('kgKmCargoServiceType')
    setIsSave(false);
  }
  const excelCol=kgkmTableHead?.filter(col => col.field !== 'action')
  return (
    <>
    {!showKgKmUpload?<>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '10px 0', paddingTop:'5px' }}>
        <Box sx={{ display: 'flex', gap: '16px', paddingBottom:'5px' }} className="reportButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'kgKmCargoServiceType'}
              label={'Cargo Service Type'}
              searchPlaceholder={'Search Cargo Service Type'}
              data={cargoServiceTypes}
              defaultvalue={filters?.cargoServiceType?.name || ''}
              value={filters?.cargoServiceType?.name || ''}
              onSelect={(val) => {
                setShowTable(false)
                setFilters((prev) => ({
                  ...prev,
                  cargoServiceType: val
                }))
              }}
              disabled={true}
              idKey={`id`}
              dataKey={`name`}
              minWidth="230px"
              nextId={'multi_cargo_service_type'}
              prevId={``}
              onSelResetVal={true}

            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id='multi_cargo_service_type'
              label={'Select Service Type'}
              data={serviceTypeOpt || []}
              defaultvalue={filters?.multiCargoServiceType?.ServiceType || ''}
              value={filters?.multiCargoServiceType?.ServiceType || ''}
              width="100%"
              searchPlaceholder={'Search Service Type'}
              dataKey={`ServiceType`}
              idKey={`ServiceTypeID`}
              listWidth="200px"
              // resetFlag={resetFilter}
              onSelect={(val) => {
                setShowTable(false)
                setFilters((prev) => ({
                  ...prev,
                  multiCargoServiceType: val
                }))
              }}
              nextId={'kg-km-ConsType'}
              prevId={`kgKmCargoServiceType`}
              onSelResetVal={true}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id='kg-km-ConsType'
              label={'Consignment Type'}
              data={consTypeList || []}
              defaultvalue={filters?.consType?.name || ''}
              value={filters?.consType?.name || ''}
              width="100%"
              searchPlaceholder={'Search Consignment Type'}
              dataKey={`name`}
              idKey={`id`}
              listWidth="200px"
              // resetFlag={resetFilter}
              onSelect={(val) => {
                setShowTable(false)
                setFilters((prev) => ({
                  ...prev,
                  consType: val
                }))
              }}
              nextId='load_btn'
              prevId={'multi_cargo_service_type'}
              onSelResetVal={true}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, 'save_btn', 'kg-km-ConsType', () => { loadServiceType(page, rowsPerPage) })}
              id={'load_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
              onClick={() => loadServiceType(page, rowsPerPage)}
            >
              Load
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="outlined"
              onClick={(e) => { handleSave(e) }}
              onKeyDown={(e) => navigation3(e, 'delete_btn', 'load_btn', () => { })}
              id={'save_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn cancel-btn"
            >
              SAVE
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="outlined"
              onKeyDown={(e) => navigation3(e, 'add_new_rate_btn', 'save_btn', () => { updateModal(true, 'kg_kmg_rate_delete') })}
              id={'delete_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn cancel-btn"
              onClick={() => updateModal(true, 'kg_kmg_rate_delete')}
            >
              Delete
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="outlined"
              onKeyDown={(e) => navigation3(e, 'history_btn', 'delete_btn', () => { updateModal(true, 'kg_kmg_rate_upload') })}
              id={'add_new_rate_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn cancel-btn"
              // onClick={() => updateModal(true, 'kg_kmg_rate_upload')}
              onClick={() =>setShowKgKmUpload(true)}
           >
              + Add NEW RATES
            </Button>
          </Item>
          {/* <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="outlined"
              onKeyDown={(e) => navigation3(e, 'kgKmCargoServiceType', 'add_new_rate_btn', () => { updateModal(true, 'kg_kmg_rate_history') })}
              id={'history_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn cancel-btn"
              onClick={() => updateModal(true, 'kg_kmg_rate_history')}
            >
              Show History
            </Button>
          </Item> */}
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <div

            >
              <ReactHtmlTableToExcel
                id="exportExcelBtn"
                className="receiveitemExcelBtn"
                table="KGKMRateMatrix"
                filename="KG-KM Rate Matrix"
                sheet="tablexls"
                buttonText="Export to Excel"
              />
            </div>
          </Item>
        </Box>
      </Box>
      {
        showTable &&<>
        <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight:'52vh' }}>
          <Table
            stickyHeader
            size="small"
            aria-label="a dense table"
            sx={{
              '&.MuiTableCell-root': {
                padding: '6px 8px!important',
              },
            }}
          >
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
              <TableRow>
                {kgkmTableHead.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    sx={{
                      ...col.headerSx,
                      backgroundColor: '#DAEDFE',
                      height: '40px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#444',
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {kgkmTableHead?.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    sx={{
                      ...col.headerSx,
                      height: '40px',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444',
                    }}
                  >
                    {col.showfilter ? (
                      //  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'ManualLRNo') }} />
                      <FilterInput label="Contains" onChange={(e) => handleChangeContain(e, col.field)} />
                    ) : (
                      ''
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={14}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '500',
                  marginLeft: '5px',
                }}
              >
                {tableData?.map((item, index) => (
                  <KgKmTblRow item={item} index={index} key={index} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
              <Table
                stickyHeader
                size="small"
                aria-label="a dense table"
                sx={{ '&.MuiTableCell-root': { padding: '6px 8px!important' }, display: 'none' }}
                id="KGKMRateMatrix"
              >
                <RenderTable header={excelCol} data={tableData} key1={'ads23'} key2={'bcgd34'} key3={'ndbfh343'} />
              </Table>
        </TableContainer>
        <TablePaginationCustom totRowCount={totalNoOfRows} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                setPage(newPage);loadServiceType(newPage,rowsPerPage)
            }} handleChangeRowsPerPage={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
                loadServiceType(0,parseInt(event.target.value, 10))
            }} />
        </>
      }
      </>:<></>}
      {showKgKmUpload ? showKgKmUploadPopup() : null}
      {showModal && 'kg_kmg_rate_history' === modalType ? showKgKmHistoryPopup() : null}
      {showModal && 'kg_kmg_rate_delete' === modalType ? showKgKmDeletePopup() : null}
      <SuccessAndErrorModal handleClose={() => { handleCloseSuccessModal() }} open={isSave} title={'KG-KM Rate Matrix\nUpdated Successfully!'} modalStyle={modalStyle} />
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getFocApprConsTypeData, getServiceTypeListAllData, GetKgKmRateMatrixTblData, kgKmRateMatrixUpdate, GetKgKmRateMatrixHistoryTblData, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(KGKMRateMatrix)
